export default {
    MODAL_GENERATE_BALANCE_SAVE: 'modalGenerateBalanceSave',
}